import { useSoundPath } from "hooks/useSoundPath";
import { useState } from "react";

const ProfileChangeEmail = ({
  successIcon,
  failIcon,
  close,
  onUpdateEmail,
}) => {
  const [step, setStep] = useState("start");
  const [email, setEmail] = useState("");
  const playsound = useSoundPath();

  const changeInputHandler = (event) => {
    setEmail(event.target.value);
  };

  const isDisabledSubmit = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  return (
    <section className="profile-change__popup">
      {step === "start" && (
        <>
          <h2 className="modal-window__title">Change Email</h2>
          <form className="profile-change__form">
            <p className="profile-change__row">
              <label htmlFor="email">Enter new email</label>
              <input
                type="email"
                id="email"
                onInput={changeInputHandler}
                placeholder="New Email"
                value={email}
              />
            </p>
            <button
              type="button"
              className="profile-change__form-submit"
              disabled={isDisabledSubmit}
              onClick={() => onUpdateEmail(email, setStep)}
            >
              Continue
            </button>
          </form>
        </>
      )}
      {step === "success" && (
        <>
          <header className="modal-window__header">
            <img src={successIcon} className="modal-window__icon" alt="" />
            <h5 className="modal-window__title">Success!</h5>
            <p className="modal-window__info">Your email was updated</p>
          </header>
          <footer className="modal-window__footer">
            <button className="modal-window__footer-submit" onClick={close}>
              Done
            </button>
          </footer>
        </>
      )}

      {step === "fail" && (
        <>
          <header className="modal-window__header">
            <img src={failIcon} className="modal-window__icon" alt="" />
            <h5 className="modal-window__title">Oops...</h5>
            <p className="modal-window__info">
              Your email has not been changed
            </p>
          </header>
          <footer className="modal-window__footer">
            <button className="modal-window__footer-submit" onClick={close}>
              Done
            </button>
          </footer>
        </>
      )}
    </section>
  );
};

export default ProfileChangeEmail;
